






















import {Component, Prop, Vue} from "vue-property-decorator";
import {DeviceEvent} from "../../types/core-push";
import TimestampAgo from "@/components/TimestampAgo.vue";

@Component({components: {
    TimestampAgo
  }
})
export default class EventRow extends Vue {

  @Prop({ default: () => {},  type: Object}) deviceEvent!:DeviceEvent;
  @Prop({ default: 0,  type: Number}) index!: number;

  get warningLevel(){
    switch(this.deviceEvent.level){
      case "warning":
        return "warning";
      case "error":
        return "danger";
      default:
        return ""
    }
  }
}

